(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bht-symptom-check"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-bht-print]');
    if (!button) return;
    const section = button.closest('.bht-sc');
    const details = button.closest('details');
    const checklist = button.closest('[data-bht-checklist]');
    if (details) details.open = true;
    const text = (element) => (element ? element.textContent.trim() : '');
    const esc = (value) => value.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    let win = null;
    if (checklist) {
      const clone = checklist.cloneNode(true);
      for (const control of clone.querySelectorAll('button')) control.remove();
      const heading = text(section ? section.querySelector('.bht-sc__heading') : null);
      const intro = section ? section.querySelector('.bht-sc__intro') : null;
      const stamp = window.location.hostname + ' \u00b7 ' + new Date().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
      const css = 'body{margin:32px auto;padding:0 24px;max-width:720px;color:#000;font:14px/1.55 -apple-system,BlinkMacSystemFont,"Segoe UI",Helvetica,Arial,sans-serif}' +
        'h1{margin:0 0 20px;font:400 24px/1.15 Georgia,"Times New Roman",serif}p{margin:0 0 12px}' +
        'ol{margin:16px 0 20px;padding-left:22px}li{margin:0 0 10px}strong{font-weight:700}' +
        '.stamp{margin-top:24px;padding-top:12px;border-top:1px solid #999;font-size:12px;color:#444}@page{margin:18mm}';
      const html = '<!doctype html><html lang="' + esc(document.documentElement.lang || 'en') + '"><head><meta charset="utf-8"><title>' + esc(document.title) + '</title><style>' + css + '</style></head><body>' +
        (heading ? '<h1>' + esc(heading) + '</h1>' : '') + (intro ? intro.innerHTML : '') + clone.innerHTML +
        '<p class="stamp">' + esc(stamp) + '</p></body></html>';
      try { win = window.open('', '_blank', 'width=820,height=980'); } catch (error) { win = null; }
      if (win && win.document) {
        win.document.open();
        win.document.write(html);
        win.document.close();
        win.addEventListener('afterprint', () => win.close());
        window.setTimeout(() => { win.focus(); win.print(); }, 350);
        return;
      }
    }
    if (section) section.setAttribute('data-bht-printing', '');
    document.body.classList.add('bht-sc-printing');
    const cleanup = () => {
      if (section) section.removeAttribute('data-bht-printing');
      document.body.classList.remove('bht-sc-printing');
      window.removeEventListener('afterprint', cleanup);
    };
    window.addEventListener('afterprint', cleanup);
    window.print();
    window.setTimeout(cleanup, 60000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gp-action-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DISMISS_KEY = 'gp-abar-dismissed';
    var bars = [];
    var ticking = false;

    function remembered() {
      try { return window.sessionStorage.getItem(DISMISS_KEY) === '1'; } catch (e) { return false; }
    }

    function footerEl() {
      return document.querySelector('.shopify-section-group-footer-group') ||
        document.querySelector('footer.footer') ||
        document.querySelector('[role="contentinfo"]');
    }

    function setup(el) {
      if (el.hasAttribute('data-gp-abar-ready')) return;
      el.setAttribute('data-gp-abar-ready', '');
      document.body.appendChild(el);
      if (el.getAttribute('data-remember') === 'true' && remembered()) el.classList.add('gp-abar--dismissed');

      var state = { el: el, observers: [], yielding: [] };
      function onIntersect(entries) {
        for (var i = 0; i < entries.length; i++) {
          var idx = state.yielding.indexOf(entries[i].target);
          if (entries[i].isIntersecting && idx === -1) state.yielding.push(entries[i].target);
          if (!entries[i].isIntersecting && idx !== -1) state.yielding.splice(idx, 1);
        }
        el.classList.toggle('gp-abar--yield', state.yielding.length > 0);
      }
      function watch(target, rootMargin) {
        var io = new IntersectionObserver(onIntersect, { rootMargin: rootMargin });
        io.observe(target);
        state.observers.push(io);
      }
      if ('IntersectionObserver' in window) {
        // The page's own CTA section: step aside only while it crosses the middle 20% of the screen,
        // so the bar is not gone for the whole time any edge of a tall section is visible.
        var anchor = el.getAttribute('data-hide-anchor');
        var t = anchor ? document.getElementById(anchor) : null;
        if (t) watch(t, '-40% 0px -40% 0px');
        // The footer: step aside as soon as any of it is on screen, so the bar never covers it.
        if (el.getAttribute('data-hide-footer') === 'true') {
          var f = footerEl();
          if (f) watch(f, '0px');
        }
      }
      bars.push(state);
      check();
    }

    function teardown(id) {
      for (var i = bars.length - 1; i >= 0; i--) {
        if (id && bars[i].el.getAttribute('data-gp-abar') !== id) continue;
        for (var k = 0; k < bars[i].observers.length; k++) bars[i].observers[k].disconnect();
        if (bars[i].el.parentNode) bars[i].el.parentNode.removeChild(bars[i].el);
        bars.splice(i, 1);
      }
    }

    function check() {
      ticking = false;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      var vh = window.innerHeight || 1;
      for (var i = 0; i < bars.length; i++) {
        var mult = parseFloat(bars[i].el.getAttribute('data-reveal-vh'));
        if (isNaN(mult)) continue;
        bars[i].el.classList.toggle('gp-abar--visible', y >= vh * mult);
      }
    }

    var selectedAt = 0;

    function onScroll() {
      // Theme editor: a selected bar is forced visible for editing; the first real scroll afterwards
      // (the editor's own scroll-to-section lands within the first second) hands it back to the normal rules.
      if (selectedAt && Date.now() - selectedAt > 1000) {
        selectedAt = 0;
        for (var i = 0; i < bars.length; i++) bars[i].el.classList.remove('gp-abar--selected');
      }
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }

    function init(root) {
      var found = (root || document).querySelectorAll('[data-gp-abar]:not([data-gp-abar-ready])');
      for (var i = 0; i < found.length; i++) setup(found[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-gp-abar-close]');
      if (!btn) return;
      var bar = btn.closest('[data-gp-abar]');
      if (!bar) return;
      bar.classList.add('gp-abar--dismissed');
      if (bar.getAttribute('data-remember') === 'true') {
        try { window.sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
      }
    });

    document.addEventListener('shopify:section:load', function (event) {
      teardown(event.detail ? event.detail.sectionId : null);
      init(event.target);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      teardown(event.detail ? event.detail.sectionId : null);
    });
    document.addEventListener('shopify:section:select', function (event) {
      var id = event.detail ? event.detail.sectionId : null;
      for (var i = 0; i < bars.length; i++) {
        if (bars[i].el.getAttribute('data-gp-abar') === id) {
          bars[i].el.classList.add('gp-abar--selected');
          selectedAt = Date.now();
        }
      }
    });
    document.addEventListener('shopify:section:deselect', function () {
      for (var i = 0; i < bars.length; i++) bars[i].el.classList.remove('gp-abar--selected');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hp-hero-video')) {
    class HpHeroVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('.hp-hero__control');
        if (!this.video) return;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 749px)');
        this.userPaused = false;
        this.onClick = () => {
          if (this.video.paused) {
            this.userPaused = false;
            this.play();
          } else {
            this.userPaused = true;
            this.pause();
          }
        };
        this.onVisibility = () => {
          if (document.hidden) {
            this.video.pause();
          } else if (!this.userPaused && this.allowed()) {
            this.play();
          }
        };
        this.button?.addEventListener('click', this.onClick);
        document.addEventListener('visibilitychange', this.onVisibility);
        if (this.allowed()) {
          this.play();
        } else {
          this.sync();
        }
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      allowed() {
        if (this.reduce.matches) return false;
        if (this.video.hasAttribute('data-skip-mobile') && this.mobile.matches) return false;
        return true;
      }

      async play() {
        try {
          await this.video.play();
        } catch (error) {
          this.video.pause();
        }
        this.sync();
      }

      pause() {
        this.video.pause();
        this.sync();
      }

      sync() {
        const playing = !this.video.paused;
        this.dataset.state = playing ? 'playing' : 'paused';
        if (!this.button) return;
        this.button.setAttribute('aria-label', playing ? this.button.dataset.labelPause : this.button.dataset.labelPlay);
      }
    }
    customElements.define('hp-hero-video', HpHeroVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    // Selects ALL anchor links on the page. If you only want links inside
    // the multicolumn section, change the selector to:
    // const anchorLinks = document.querySelectorAll('.multicolumn-class a[href^="#"]');
    const anchorLinks = document.querySelectorAll('a[href^="#"]');

    anchorLinks.forEach(anchor => {
      // Prevent attaching multiple listeners if the script is somehow re-initialized
      if (anchor.dataset.scrollInitialized) return;
      anchor.dataset.scrollInitialized = 'true';

      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        const targetId = this.getAttribute("href");

        if (targetId === "#") {
          window.scrollTo({ top: 0, behavior: "smooth" });
          return;
        }

        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          const offset = 150; 
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pem-app-screens"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pem-app-screens')) {
    class PemAppScreens extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-screen]'));
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.toggle = this.querySelector('[data-toggle]');
        this.index = Math.max(0, this.slides.findIndex((el) => el.classList.contains('is-active')));
        this.paused = false;
        this.hovering = false;
        this.focused = false;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        const seconds = parseInt(this.dataset.interval, 10);
        this.delay = (Number.isFinite(seconds) && seconds > 0 ? seconds : 5) * 1000;
        this.onEnter = () => { this.hovering = true; };
        this.onLeave = () => { this.hovering = false; };
        this.onFocusIn = () => { this.focused = true; };
        this.onFocusOut = (event) => { if (!this.contains(event.relatedTarget)) this.focused = false; };
        this.onToggle = () => this.setPaused(!this.paused);
        this.onMotion = () => this.syncToggle();
        this.onTab = (event) => {
          const at = parseInt(event.currentTarget.dataset.tab, 10);
          if (!Number.isFinite(at)) return;
          this.setPaused(true);
          this.show(at);
        };
        this.onBlockSelect = (event) => {
          const id = event.detail && event.detail.blockId;
          const at = this.slides.findIndex((el) => el.dataset.blockId === id);
          if (at < 0) return;
          this.setPaused(true);
          this.show(at);
        };
        for (const tab of this.tabs) tab.addEventListener('click', this.onTab);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        if (this.slides.length < 2 || this.dataset.autoplay !== 'true') return;
        this.addEventListener('mouseenter', this.onEnter);
        this.addEventListener('mouseleave', this.onLeave);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        this.toggle?.addEventListener('click', this.onToggle);
        this.reduce.addEventListener?.('change', this.onMotion);
        this.syncToggle();
        this.timer = window.setInterval(() => this.tick(), this.delay);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.reduce?.removeEventListener?.('change', this.onMotion);
      }

      syncToggle() {
        if (this.toggle) this.toggle.hidden = this.reduce.matches;
      }

      setPaused(value) {
        this.paused = value;
        this.toggle?.setAttribute('aria-pressed', value ? 'true' : 'false');
      }

      tick() {
        if (this.paused || this.hovering || this.focused || this.reduce.matches || document.hidden) return;
        this.show(this.index + 1);
      }

      show(next) {
        const count = this.slides.length;
        if (!count) return;
        const target = ((next % count) + count) % count;
        if (target === this.index) return;
        this.slides[this.index].classList.remove('is-active');
        this.slides[this.index].setAttribute('aria-hidden', 'true');
        this.tabs[this.index]?.setAttribute('aria-pressed', 'false');
        this.index = target;
        this.slides[this.index].classList.add('is-active');
        this.slides[this.index].removeAttribute('aria-hidden');
        this.tabs[this.index]?.setAttribute('aria-pressed', 'true');
      }
    }
    customElements.define('pem-app-screens', PemAppScreens);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-compare-table"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* The scroll wrapper is a keyboard stop (and a named region) only while the table overflows it. */
    const sync = () => {
      for (const el of document.querySelectorAll('[data-ph-cmp-scroll]')) {
        if (el.scrollWidth > el.clientWidth + 1) {
          el.setAttribute('tabindex', '0');
          el.setAttribute('role', 'region');
          if (el.dataset.labelId) el.setAttribute('aria-labelledby', el.dataset.labelId);
        } else {
          el.removeAttribute('tabindex');
          el.removeAttribute('role');
          el.removeAttribute('aria-labelledby');
        }
      }
    };
    let t = null;
    const queue = () => {
      if (t) cancelAnimationFrame(t);
      t = requestAnimationFrame(sync);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
    window.addEventListener('resize', queue);
    window.addEventListener('load', queue);
    document.addEventListener('shopify:section:load', queue);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-elite-band"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ph-elite-screens')) {
    class PhEliteScreens extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-screen]'));
        this.toggle = this.querySelector('[data-toggle]');
        this.index = Math.max(0, this.slides.findIndex((el) => el.classList.contains('is-active')));
        this.paused = false;
        this.hovering = false;
        this.focused = false;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        const seconds = parseInt(this.dataset.interval, 10);
        this.delay = (Number.isFinite(seconds) && seconds > 0 ? seconds : 5) * 1000;
        this.onEnter = () => { this.hovering = true; };
        this.onLeave = () => { this.hovering = false; };
        this.onFocusIn = () => { this.focused = true; };
        this.onFocusOut = (event) => {
          if (!this.contains(event.relatedTarget)) this.focused = false;
        };
        this.onToggle = () => this.setPaused(!this.paused);
        this.onMotion = () => this.syncToggle();
        this.onBlockSelect = (event) => this.selectBlock(event);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        if (this.slides.length < 2 || this.dataset.autoplay !== 'true') return;
        this.addEventListener('mouseenter', this.onEnter);
        this.addEventListener('mouseleave', this.onLeave);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        this.toggle?.addEventListener('click', this.onToggle);
        this.reduce.addEventListener?.('change', this.onMotion);
        this.syncToggle();
        this.timer = window.setInterval(() => this.tick(), this.delay);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.reduce?.removeEventListener?.('change', this.onMotion);
      }

      syncToggle() {
        if (!this.toggle) return;
        this.toggle.hidden = this.reduce.matches;
      }

      setPaused(value) {
        this.paused = value;
        this.toggle?.setAttribute('aria-pressed', value ? 'true' : 'false');
      }

      tick() {
        if (this.paused || this.hovering || this.focused || this.reduce.matches || document.hidden) return;
        this.show(this.index + 1);
      }

      show(next) {
        const count = this.slides.length;
        if (!count) return;
        const target = ((next % count) + count) % count;
        if (target === this.index) return;
        this.slides[this.index].classList.remove('is-active');
        this.slides[this.index].setAttribute('aria-hidden', 'true');
        this.index = target;
        this.slides[this.index].classList.add('is-active');
        this.slides[this.index].removeAttribute('aria-hidden');
      }

      selectBlock(event) {
        const id = event.detail && event.detail.blockId;
        const at = this.slides.findIndex((el) => el.dataset.blockId === id);
        if (at < 0) return;
        this.setPaused(true);
        this.show(at);
      }
    }
    customElements.define('ph-elite-screens', PhEliteScreens);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ph-price-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sync = () => {
      for (const el of document.querySelectorAll('[data-ph-pl-scroll]')) {
        if (el.scrollWidth > el.clientWidth + 1) {
          el.setAttribute('tabindex', '0');
        } else {
          el.removeAttribute('tabindex');
        }
      }
    };
    let t = null;
    const queue = () => {
      if (t) cancelAnimationFrame(t);
      t = requestAnimationFrame(sync);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', sync);
    } else {
      sync();
    }
    window.addEventListener('resize', queue);
    document.addEventListener('shopify:section:load', queue);
    /* The inline accordion script (after the groups markup) announces every open / close. */
    document.addEventListener('ph-pl:layout', queue);
  })();

  } catch(e) { console.error(e); }
})();
})();
